import { Edit } from 'lucide-react';
import { Button } from '@/components/ui/button';
import SubtramiteStatusBadge from '@/subtramites/SubtramiteStatusBadge';
import { formatDate } from '@/common/utils/date';


const HeaderSubtramite = ({ data, onClickEdit, visible, editShow, subtramiteKey }) => {
  if (!visible) return <></>;
  return (
    <div className="flex flex-wrap text-sm py-4">
      {data?.cuenta && (
        <div className="mr-6 flex">
          <span className="mr-2">N° de cuenta:</span>
          <span className="font-semibold">{data.cuenta}</span>
        </div>
      )}

      {data?.distrito && (
        <div className="mr-6 flex">
          <span className="mr-2">Distrito:</span>
          <span className="font-semibold">{data.distrito}</span>
        </div>
      )}

      <div className="mr-6 flex">
        <span className="mr-2">Fecha de inicio:</span>
        <span className="font-semibold">{formatDate(data.fecini)}</span>
      </div>
      <div className="mr-4 flex">
        <span className="mr-2">N° de trámite:</span>
        <span className="font-semibold">{data.tramite_id}</span>
      </div>

      {data?.estado && (
        <div className="mr-4 flex">
          <SubtramiteStatusBadge subtramite={data} relative subtramiteKey={subtramiteKey} />
        </div>
      )}


      {editShow && (
        <Button
          variant="outline"
          size="sm"
          onClick={onClickEdit}
          className="mx-2 rounded-full w-6 h-6 p-0 text-orange-500 border-orange-300"
        >
          <Edit className="h-3 w-3" />
        </Button>
      )}
    </div>
  );
}

export default HeaderSubtramite;